export const headerData = [
  {
    text: "",
  },
  {
    text: "SKU ID",
  },
  {
    text: "Name",
  },
  {
    text: "Category",
  },
  // {
  //   text: "Visibility",
  // },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such product exists. Create one?",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "productCityLevelImage",
    type: "img",
    prepend: "",
  },
  {
    key: "productCityLevelSku",
    type: "",
    prepend: "",
  },
  {
    key: "productCityLevelTitle",
    type: "",
    prepend: "",
  },
  {
    key: "productCityLevelCategories",
    type: "",
    prepend: "",
  },
  // {
  // 	key: 'productCityLevelVisibility',
  // 	type: 'Array',
  // 	prepend: '',
  // },
];
export const ALLOWED_ROLE = "Commercial Super User";
